import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-external-callback-mapping',
  templateUrl: './external-callback-mapping.component.html',
  styleUrls: ['./external-callback-mapping.component.scss']
})
export class ExternalCallbackMappingComponent implements OnInit {

    @Input() portalService: PortalService;
    formData: FormGroup;
    mappings: any = [];
    loading: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, private campHandler: VnaCampaignService, private alertService: AlertaService) {
        this.formData = this.fb.group({
            'mappings' : this.fb.array([])
        })
    }

    createMappingVar(data?: Object): FormGroup {
        let rangeData = (data) ? data : { variable_name: '', current_value: '', target_value: '' };
        return this.fb.group({
            variable_name: new FormControl(rangeData['variable_name'], Validators.required),
            current_value: new FormControl(rangeData['current_value'], Validators.required),
            target_value: new FormControl(rangeData['target_value'], Validators.required),
        });
    }

    addMappingVar(data?: Object): void {
        this.mappings = this.formData.get('mappings') as FormArray;
        this.mappings.push(this.createMappingVar(data));
    }

    removeMapping(i: number): void {
        this.mappings.removeAt(i);
    }

    saveMappings(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };
        let updateData = this.formData.value['mappings'];
        this
            .campHandler
            .savePortalService(criteria, 'external_callback_parameters', this.portalService.alias, { 'external_callback_vars_mappings_change' : updateData })
            .subscribe(
                (r) => {
                    this.loading = false;
                    this.alertService.addAlert('success', 'External callbacks mappings updated successfully');
                }
            )
    }


    ngOnInit() {

        let mappings: Array<any> = this.portalService.getConfigKey('external_callback_vars_mappings_change', []);
        if(mappings.length > 0){
            mappings.forEach( (mapping) => {
                this.addMappingVar({ variable_name : mapping['variable_name'], current_value: mapping['current_value'], target_value: mapping['target_value'] });
            });
        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/external-callback-mapping/external-callback-mapping.component.ts